<template>
    <div class="text-center loading" v-if="!is_show">
        <b-spinner style="width: 10rem; height: 10rem;" type="grow" variant="info"/>
    </div>
    <div v-else>
        <hr>
        <form @submit.prevent="submitAnswers">
            <div v-for="(question_section, index_section) in questionnaire" :key="index_section">
                <b-row>
                    <b-col md="12">
                        <b>{{question_section.number}}&emsp;{{question_section.title}}</b>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <p class="text-indent" v-html="question_section.description"></p>
                    </b-col>
                </b-row>
                <!-- Section Asset -->
                <b-row align-v="center" v-if="question_section.asset != null">
                    <b-col md="12" class="profile-padding">
                        <!-- video link -->
                        <b-embed
                                v-if="question_section.asset.type === 'url'"
                                type="iframe"
                                aspect="16by9"
                                :src="question_section.asset.url"
                                allowfullscreen
                        />
                        <!--/video link -->

                        <!-- Image -->
                        <b-img v-else-if="question_section.asset.type === 'image'"
                               :src="serverUrl + '/' + question_section.asset.url"
                               fluid
                               alt="Responsive image"/>
                        <!--/Image-->

                        <!-- MP4 -->
                        <b-embed v-else-if="question_section.asset.type === 'video'"
                                 type="video" aspect="4by3" controls>
                            <source :src="serverUrl + '/' + question_section.asset.url"
                                    type="video/mp4;codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"/>
                        </b-embed>
                        <!--/MP4-->
                    </b-col>
                </b-row>
                <!--/Section Asset -->


                <div v-for="(question, index_question) in question_section.questions" :key="question.id">
                    <!-- Question Asset -->
                    <b-row align-v="center" v-if="question.asset_question != null">
                        <b-col md="12" class="profile-padding">
                            <!-- video link -->
                            <b-embed
                                    v-if="question.asset_question.type === 'url'"
                                    type="iframe"
                                    aspect="16by9"
                                    :src="question.asset_question.url"
                                    allowfullscreen
                            />
                            <!--/video link -->

                            <!-- Image -->
                            <b-img v-else-if="question.asset_question.type === 'image'"
                                   :src="serverUrl + '/' + question.asset_question.url"
                                   fluid
                                   alt="Responsive image"/>
                            <!--/Image-->

                            <!-- MP4 -->
                            <b-embed v-else-if="question.asset_question.type === 'video'"
                                     type="video" aspect="4by3" controls>
                                <source :src="serverUrl + '/' + question.asset_question.url"
                                        type="video/mp4;codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"/>
                            </b-embed>
                            <!--/MP4-->
                        </b-col>
                    </b-row>
                    <!--/Question Asset -->
                    <b-card-group deck>
                        <b-card header-tag="header">
                            <h6 slot="header" class="mb-0">
                                {{question.number}} {{question.title}}
                            </h6>
                            <b-card-text>
                                <!-- radio -->
                                <div v-if="question.answer_type_id === 1">
                                    <b-form-radio-group :key="question.id"
                                                        :name="`${question.id}`"
                                                        :required="true"
                                                        @change="setAnswersCache"
                                                        v-model="getAnswersByQuestionId(question.id).answer_id"
                                    >
                                        <b-form-radio class="col-xs-12 col-md-3" style="padding-top: 5px"
                                                      v-for="(answer, index_answer) in question.answers"
                                                      v-model="getAnswersByQuestionId(question.id).answer_id"
                                                      :key="index_answer"
                                                      :value=answer.id
                                        >
                                            <b-img v-if="answer.image !== null"
                                                   :src="serverUrl + '/' + answer.image"
                                                   width="30px"
                                                   height="30px"
                                            />
                                            {{answer.name}}
                                            <b-form-input v-if="answer.is_other"
                                                          type="text"
                                                          v-model="getAnswersByQuestionId(question.id).answer_other_value"
                                                          placeholder="รายละเอียด"
                                            />
                                        </b-form-radio>
                                    </b-form-radio-group>
                                </div>
                                <!--/radio -->

                                <!-- date -->
                                <b-row v-else-if="question.answer_type_id === 2">
                                    <b-col md="3" xs="6">
                                        <b-form-input v-for="(answer, index_answer) in question.answers"
                                                      :key="index_answer"
                                                      v-model="getAnswersByQuestionId(question.id).answer_value"
                                                      type="date"
                                                      required
                                        />
                                    </b-col>
                                </b-row>
                                <!--/date -->

                                <!--input -->
                                <div v-else-if="question.answer_type_id === 3">
                                    <b-row class="my-1" v-for="(answer, index_answer) in question.answers"
                                           :key="index_answer">
                                        <b-col v-if="answer.name !== null"
                                               :class="{ 'col-3' : answer.name !== null}">
                                            <label :for="answer.id.toString()">{{answer.name}}</label>
                                        </b-col>
                                        <b-col :class="{ 'col-3' : answer.name !== null && answer.unit !== null}">
                                            <b-form-input :id="answer.id.toString()"
                                                          v-model="getAnswersByQuestionId(question.id).answer_value"
                                                          type="text"
                                                          required
                                            />
                                        </b-col>
                                        <b-col v-if="answer.unit !== null"
                                               :class="{ 'col-3' : answer.unit !== null}">
                                            <label :for="answer.id.toString()">
                                                {{answer.unit}}
                                            </label>
                                        </b-col>
                                    </b-row>
                                </div>
                                <!--/input -->

                                <!-- check box -->
                                <div v-else-if="question.answer_type_id === 4">
                                    <b-form-checkbox-group stacked
                                                           v-model="getAnswersByQuestionId(question.id).answer_id">
                                        <b-form-checkbox v-for="(answer, index_answer) in question.answers"
                                                         v-model="getAnswersByQuestionId(question.id).answer_id"
                                                         :key="index_answer"
                                                         :value="answer.id"
                                        >
                                            {{answer.name}}
                                            <b-form-input v-if="answer.is_other"
                                                          type="text"
                                                          v-model="getAnswersByQuestionId(question.id).answer_other_value"
                                                          placeholder="รายละเอียด"
                                            />
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>
                                <!--/check box -->

                                <!-- child questions -->
                                <div v-if="question.all_child_questions.length > 0">
                                    <child-questions :question="question" :form="form"></child-questions>
                                </div>
                                <!--/child questions -->
                            </b-card-text>
                        </b-card>
                    </b-card-group>
                    <br>
                </div>
            </div>
            <b-row>
                <div class="col-md-6 offset-md-3 text-center">
                    <button type="submit" class="btn btn-success btn-block" v-if="saving===false">
                        <icon name="file-export"></icon>
                        บันทึกแบบสอบถาม
                    </button>
                    <b-button variant="success" block disabled v-else>
                        <b-spinner small type="grow"/>
                        Loading...
                    </b-button>
                </div>
            </b-row>
        </form>
    </div>
</template>

<script>
    import Service from "../../services/index";
    import ChildQuestions from "@/components/Questions/ChildQuestions"
    import {base_domain} from "../../utils/Constants";
    import BContainer from "bootstrap-vue/src/components/layout/container";
    import BRow from "bootstrap-vue/src/components/layout/row";
    import BCol from "bootstrap-vue/src/components/layout/col";
    import BImg from "bootstrap-vue/src/components/image/img";
    import BCardGroup from "bootstrap-vue/src/components/card/card-group";
    import BCard from "bootstrap-vue/src/components/card/card";
    import BCardText from "bootstrap-vue/src/components/card/card-text";
    import BFormRadioGroup from "bootstrap-vue/src/components/form-radio/form-radio-group";
    import BFormRadio from "bootstrap-vue/src/components/form-radio/form-radio";
    import BFormInput from "bootstrap-vue/src/components/form-input/form-input";
    import BFormCheckboxGroup from "bootstrap-vue/src/components/form-checkbox/form-checkbox-group";
    import BFormCheckbox from "bootstrap-vue/src/components/form-checkbox/form-checkbox";
    import BEmbed from "bootstrap-vue/src/components/embed/embed";
    import BSpinner from "bootstrap-vue/src/components/spinner/spinner";
    import BButton from "bootstrap-vue/src/components/button/button";
    import {mapGetters} from "vuex";


    export default {
        name: "Questions",
        components: {
            ChildQuestions,
            BButton,
            BSpinner,
            BEmbed,
            BFormCheckbox,
            BFormCheckboxGroup,
            BFormInput,
            BFormRadio,
            BFormRadioGroup, BCardText, BCard, BCardGroup, BImg, BCol, BRow
        },
        props: {
            question_set_id: {
                type: Number
            },
        },
        data() {
            return {
                is_show: false,
                saving: false,
                useCache: false,
                questionnaire: [],
                form: {
                    question_set_id: this.question_set_id,
                    data: []
                },
                selected: '',
                serverUrl: base_domain,
                user: this.$store.state.Auth.user
            }
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters({
                cacheAnswers: "Answers/getAnswers"
            })
        },
        async created() {
            await this.initQuestions();
        },
        methods: {
            submitAnswers() {
                this.saving = true;
                Service.questions.saveAnswers(this.form)
                    .then(res => {
                        if (res.status === "success") {
                            this.$toasted.show('Save Success.', {
                                type: res.status,
                                icon: 'check',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                        } else {
                            let message = `Validate Fails.`;
                            this.$toasted.show(message, {
                                type: 'error',
                                icon: 'exclamation-circle',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                        }
                        this.removeAnswersCache();
                        this.saving = false;
                    })
                    .catch(err => {
                        this.$toasted.show(err.message, {
                            type: 'error',
                            icon: 'exclamation-circle',
                            iconPack: 'fontawesome',
                            duration: 5000
                        });
                        this.saving = false;
                    })

                this.saving = false;

            },
            initQuestions() {
                let _this = this;
                Service.questions.get(this.question_set_id)
                    .then((res) => {
                        this.questionnaire = res.questions;
                        res.questions.forEach(function (question_section) {
                            if (question_section.questions.length > 0) {
                                question_section.questions.forEach(function (question) {

                                    _this.initAnswers(question);

                                    if (question.all_child_questions.length > 0) {
                                        question.all_child_questions.forEach(function (child_question) {

                                            _this.initAnswers(child_question);
                                        })
                                    }
                                })
                            }
                        });
                    })
                    .then(() => {
                        if (this.useCache) {
                            this.form = this.cacheAnswers.find(cache => cache.question_set_id === this.question_set_id)
                        }
                        this.is_show = true;
                    });
            },
            initAnswers(question) {
                if (question.answers.length > 0) {
                    question.answers.forEach(answer => {
                        this.initAnswerModels(question, answer)
                    })
                }

                if (question.all_child_questions.length > 0) {
                    question.all_child_questions.forEach(child_questions => {
                        if (child_questions.answers.length > 0) {
                            child_questions.answers.forEach(answer => {
                                this.initAnswerModels(child_questions, answer)
                            })
                        }
                    })
                }
            },
            initAnswerModels(question, answer) {
                if (this.cacheAnswers.find(cacheAnswer => cacheAnswer.question_set_id === this.question_set_id)) {
                    this.useCache = true;
                    return false
                }

                if (this.form.data.find(answerNaja => answerNaja.question_id === answer.question_id)) {
                    return false
                }

                //answer type checkbox
                if (question.answer_type_id === 4) {
                    this.form.data = [
                        ...this.form.data,
                        {
                            'question_id': answer.question_id,
                            'answer_id': [],
                            'answer_value': [],
                            'answer_other_value': null
                        }
                    ]
                }
                //question without answer
                else if (question.answer_type_id === null) {
                    return false;
                }
                //answer type input
                else if (question.answer_type_id === 2 || question.answer_type_id === 3) {
                    this.form.data = [
                        ...this.form.data,
                        {
                            'question_id': answer.question_id,
                            'answer_id': answer.id,
                            'answer_value': '',
                            'answer_other_value': null
                        }
                    ]
                }
                //default answer type radio
                else {
                    this.form.data = [
                        ...this.form.data,
                        {
                            'question_id': answer.question_id,
                            'answer_id': '',
                            'answer_value': '',
                            'answer_other_value': null
                        }
                    ]
                }
            },
            getAnswersByQuestionId(questionId) {
                return this.form.data.find(answers => answers.question_id === questionId)
            },
            setAnswersCache() {
                this.$store.dispatch("Answers/initAnswers", this.form)
                    .then(() => {

                    });

            },
            removeAnswersCache() {
                this.$store.dispatch("Answers/removeAnswers", this.question_set_id)
                    .then(() => {

                    })

            }
        }
    }

</script>

<style scoped>
    hr {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 2px solid rgb(0, 0, 0);
    }

    .text-indent {
        text-indent: 60px;
    }

    .profile-padding {
        padding: 1.25rem;
    }

    .loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        min-height: 60vh;
    }
</style>